import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Badge, IconButton } from '@material-ui/core'
import { ReactComponent as OpenFiltersIcon } from 'assets/img/open-filters.svg'
import { ReactComponent as ClearFiltersIcon } from 'assets/img/clear-filters.svg'
import { createMyJobDataViewFilters } from 'helpers/myJobs'

class FilterIcons extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowBadge: false,
    }
  }

  componentDidMount() {
    this.setBadge()
  }

  componentDidUpdate(prevProps) {
    const { profileDataViewerFilters } = prevProps
    const {
      profileDataViewerFilters: currentRrofileDataViewerFilters,
    } = this.props

    if (currentRrofileDataViewerFilters !== profileDataViewerFilters) {
      this.setBadge()
    }
  }

  setBadge = () => {
    const { getBadgeState } = this.props

    this.setState(
      {
        isShowBadge: this.checkProfileFiltersChanges(),
      },
      () => {
        getBadgeState(this.state.isShowBadge)
      },
    )
  }

  checkProfileFiltersChanges = () => {
    const {
      locusGroups,
      locuses,
      dataFields,
      jobs,
      jobTasks,
      jobInputs,
      jobInputTypes,
    } = createMyJobDataViewFilters()

    const {
      locusGroups: activeLocusGroups,
      locuses: activeLocuses,
      dataFields: activeDataFields,
      jobs: activeJobs,
      jobTasks: activeJobTasks,
      jobInputs: activeJobInputs,
      jobInputTypes: activeJobInputTypes,
    } = this.props.profileDataViewerFilters.toJS()

    return (
      (activeDataFields.length > 0 &&
        dataFields.length !== activeDataFields.length) ||
      this.isFilterChanged(activeLocuses, locuses) ||
      this.isFilterChanged(activeLocusGroups, locusGroups) ||
      this.isFilterChanged(activeJobs, jobs) ||
      this.isFilterChanged(activeJobTasks, jobTasks) ||
      this.isFilterChanged(activeJobInputs, jobInputs) ||
      this.isFilterChanged(activeJobInputTypes, jobInputTypes)
    )
  }

  isFilterChanged = (activeData, currentData) =>
    (activeData.length &&
      activeData[0] !== -1 &&
      activeData.length !== currentData.length) ||
    activeData[0] === -1

  render() {
    const { isShowBadge } = this.state
    const { isShowFilters, onShowHiddenFilters, onResetFilters } = this.props

    return (
      <div className="filter-block icons">
        <Badge variant="dot" invisible={!isShowBadge}>
          <IconButton
            className={cn('icon-btn', { open: isShowFilters })}
            onClick={onShowHiddenFilters}>
            <OpenFiltersIcon />
          </IconButton>
        </Badge>
        <IconButton
          className={cn('icon-btn', 'reset-btn', { disabled: !isShowBadge })}
          onClick={onResetFilters}
          disabled={!isShowBadge}>
          <ClearFiltersIcon />
        </IconButton>
      </div>
    )
  }
}

FilterIcons.defaultProps = {
  getBadgeState: () => {},
  onShowHiddenFilters: () => {},
  onResetFilters: () => {},
}

FilterIcons.propTypes = {
  getBadgeState: PropTypes.func,
  profileDataViewerFilters: PropTypes.object.isRequired,
  isShowFilters: PropTypes.bool.isRequired,
  onShowHiddenFilters: PropTypes.func,
  onResetFilters: PropTypes.func,
}

export default connect(store => ({
  profileDataViewerFilters: store.getIn(['profile', 'jobsDataViewerFilters']),
}))(FilterIcons)
